import Label from "components/Label/Label";
import React, { FC, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
// import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { getUserProfile } from "actions/userActions";
import { IInput } from "types/interfaces";
import { updateProfile } from "actions/userActions";
import axios from "axios";
import { RentripsURL } from "utils/request";

export interface AccountPageProps {
  className?: string;
}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {
  const [fullName, setFullName] = useState<IInput>({
    value: "",
    warning: "",
  });
  // const [fullName, setFullName] = useState<string>( "John Doe" );
  const [displayName, setDisplayName] = useState<string>("");
  const [gender, setGender] = useState<string>("Other");
  const [email, setEmail] = useState<string>("");
  // const [birthday, setBirthday] = useState<Date | string>(moment().format());
  // const [phone, setPhone] = useState<IInput>({ value: "", warning: "" });
  const [phone, setPhone] = useState<IInput>({ value: "", warning: "" });
  const [description, setDescription] = useState<string>("");
  const [imageProfile, setImageProfile] = useState<string>("/avatar.png");

  const { loading, userProfile, error, updating, success } = useSelector(
    (state: RootState) => state.userProfile
  );

  const { userInfo } = useSelector((state: RootState) => state.userInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userProfile) {
      setImageProfile(userProfile.avatar);
      setFullName({ value: userProfile.fullName, warning: "" });
      setDisplayName(userProfile.displayName);
      setGender(userProfile.gender);
      setEmail(userInfo.email);
      // setBirthday(userProfile.birthday.substring(0,10));
      setPhone({ value: userProfile.phone, warning: "" });
      setDescription(userProfile.description);
    }
  }, [userProfile, dispatch]);

  useEffect(() => {
    dispatch(getUserProfile());
  }, []);

  const handleUpdate = async (e: any) => {
    //ini cuma ditambahin console log ajaa
    const file = e.target.files[0];
    e.target.value = "";
    const formData = new FormData();
    formData.append("image", file);

    try {
      const config = {
        headers: {
          Authorization: userInfo.token,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      };

      const { data } = await axios.post(RentripsURL +"/api/upload/avatar", formData, config);
      // onUpdate({ order: id, path: data });
      setImageProfile(data);
      dispatch(
        updateProfile(
          fullName.value,
          displayName,
          gender,
          email,
          phone.value,
          description,
          data
        )
      );
      e.preventDefault();
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = (e: any) => {
    if (!fullName.value) {
      setFullName({
        value: "",
        warning: "Masukkan nama lengkap anda",
      });
    }
    if (!phone.value) {
      setPhone({
        value: "",
        warning: "Masukkan nomer telepon anda",
      });
    }
    if (fullName && phone) {
      dispatch(
        updateProfile(
          fullName.value,
          displayName,
          gender,
          email,
          phone.value,
          description,
          imageProfile
        )
      );
    }
    e.preventDefault();
  };

  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Rentrips || Akun</title>
      </Helmet>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Informasi Akun</h2>
          {error && <div>Error to get your data</div>}
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex flex-col md:flex-row">
            <div className="flex-shrink-0 flex items-start">
              <div className="relative rounded-full overflow-hidden flex">
                <Avatar sizeClass="w-32 h-32" imgUrl={imageProfile} />
                <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span className="mt-1 text-xs">Ganti Foto Profil</span>
                </div>
                <input
                  type="file"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={handleUpdate}
                />
              </div>
            </div>
            <form
              className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6"
              onSubmit={handleSubmit}
            >
              <div>
                <Label>Nama Lengkap</Label>{" "}
                <span className="text-red-500">*</span>
                <Input
                  loading={loading}
                  className="mt-1.5"
                  required
                  value={fullName.value}
                  onChange={(e) =>
                    setFullName({ value: e.target.value, warning: "" })
                  }
                />
              </div>
              {/* ---- */}
              <div>
                <div>
                  <Label>Nama Toko</Label>
                  <Input
                    loading={loading}
                    className="mt-1.5"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                  />
                </div>
              </div>
              {/* ---- */}
              <div className="mt-10">
                <Label>Jenis Kelamin</Label>
                <Select
                  loading={loading}
                  className="mt-1.5"
                  defaultValue={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option value="Male">Pria</option>
                  <option value="Female">Wanita</option>
                </Select>
              </div>
              {/* ---- */}
              <div>
                <Label>Email</Label>
                <Input
                  loading={loading}
                  className="mt-1.5 text-gray-400"
                  disabled
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              {/* ---- */}
              {/* <div className="max-w-lg">
                <Label>Tanggal Lahir</Label>
                <Input
                  className="mt-1.5"
                  type="date"
                  defaultValue={Date.now()}
                  value={birthday.toString()}
                  onChange={(e) => setBirthday(e.target.value)}
                />
              </div> */}
              <div>
                <Label>Nomor Telepon</Label>{" "}
                <span className="text-red-500">*</span>
                <div className="flex items-center">
                  <span className="h-11 px-4 py-3 dark:border-neutral-700">
                    +62
                  </span>
                  <Input
                    loading={loading}
                    type="number"
                    className="mt-1.5"
                    required
                    value={phone.value}
                    onChange={(e) =>
                      setPhone({ value: e.target.value, warning: "" })
                    }
                  />
                </div>
              </div>
              {/* ---- */}
              <div>
                <Label>Tentang Saya</Label>
                <Textarea
                  loading={loading}
                  className="mt-1.5"
                  defaultValue={description}
                  placeholder="Deskripsikan mengenai dirimu"
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              {loading || (
                <div className="pt-2">
                  <ButtonPrimary
                    loading={updating}
                    type="submit"
                    className={success && "bg-green-400 dark:bg-green-500"}
                  >
                    {success ? "Berhasil" : "Simpan Info"}
                  </ButtonPrimary>
                </div>
              )}
            </form>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPage;
